import { ThemeContext } from "app/uicomponents/macrocomponents/RootLayout";
import * as React from "react";
import { useContext } from "react";

interface SVGProps extends React.SVGProps<SVGSVGElement> {
  isActive?: boolean;
  size?: number;
}

const PortfolioIcon: React.FC<SVGProps> = ({ isActive, size, ...props }) => {
  const { isDarkMode } = useContext(ThemeContext);
  const finalColor = isActive
    ? "#FFFFFF"
    : props?.fill?.trim()
    ? props.fill.trim()
    : isDarkMode
    ? "#FFFFFF"
    : "#00132E";

  return (
    <svg
      width={size ?? 20}
      height={size ?? 16}
      viewBox="0 0 449.87 349"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color: finalColor }}
      {...props}
    >
      {/* Bottom wave paths */}
      <path
        d="M225.86,344.02c-.35,0-.69-.01-1.04-.04-3.68-.32-7.01-2.32-9.02-5.42-.1-.15-13.17-19.54-44.62-39.29-29.14-18.31-80.48-40.69-159.58-43.34-4.15-.14-7.93-2.41-10-6.01-2.07-3.6-2.13-8.01-.17-11.67l62.81-116.78c2.41-4.49,7.39-6.96,12.42-6.17l31.53,4.92c6.55,1.02,11.03,7.16,10,13.71-1.02,6.55-7.16,11.03-13.71,10l-23.13-3.61-49.83,92.65c74.7,5.6,124.55,28.17,153.9,46.9,20.02,12.77,33.39,25.45,41.32,34.19,42.86-40.96,95.3-60.83,132.97-70.37,24.33-6.16,45.37-8.87,59.5-10.06l-47.45-98.37-74.24,22.17c-6.35,1.9-13.04-1.71-14.93-8.07-1.9-6.35,1.71-13.04,8.07-14.93l84.04-25.09c5.64-1.69,11.68.98,14.24,6.29l59.75,123.86c1.8,3.73,1.55,8.12-.67,11.62-2.2,3.48-6.03,5.59-10.14,5.59-.03,0-.01,0-.09,0-1,0-32.41.11-72.83,10.43-37.23,9.5-90.05,29.89-130.31,73.07-2.28,2.45-5.46,3.82-8.78,3.82Z"
        fill="currentColor"
      />
      <path
        d="M269.03,349c-3.28,0-6.54-1.33-8.91-3.96-4.43-4.92-4.06-12.48.85-16.93,2.54-2.3,63.25-56.32,160.33-61.07,6.65-.33,12.25,4.78,12.57,11.4.32,6.62-4.78,12.25-11.4,12.57-88.17,4.32-144.85,54.4-145.41,54.9-2.29,2.06-5.17,3.08-8.03,3.08Z"
        fill="currentColor"
      />
      <path
        d="M179.41,346.01c-2.87,0-5.74-1.02-8.04-3.09-.73-.65-57.37-50.59-145.41-54.9-6.62-.32-11.72-5.95-11.4-12.57.32-6.62,5.95-11.74,12.57-11.4,97.08,4.75,157.79,58.77,160.33,61.07,4.91,4.45,5.29,12.04.84,16.95-2.37,2.62-5.63,3.95-8.9,3.95Z"
        fill="currentColor"
      />
      {/* Hexagon cluster */}
      <path
        d="M197.19,134.16v-19.55c0-4.79-2.55-9.21-6.7-11.6l-16.93-9.77c-4.14-2.39-9.25-2.39-13.4,0l-16.93,9.77c-4.14,2.39-6.7,6.82-6.7,11.6v19.55c0,4.79,2.55,9.21,6.7,11.6l16.93,9.77c4.14,2.39,9.25,2.39,13.4,0l16.93-9.77c4.14-2.39,6.7-6.82,6.7-11.6Z"
        fill="currentColor"
      />
      <path
        d="M295.17,100.56v-19.55c0-4.79-2.55-9.21-6.7-11.6l-16.93-9.77c-4.14-2.39-9.25-2.39-13.4,0l-16.93,9.77c-4.14,2.39-6.7,6.82-6.7,11.6v19.55c0,4.79,2.55,9.21,6.7,11.6l16.93,9.77c4.14,2.39,9.25,2.39,13.4,0l16.93-9.77c4.14-2.39,6.7-6.82,6.7-11.6Z"
        fill="currentColor"
      />
      <path
        d="M217.21,40.36v-13.04c0-4.79-2.55-9.21-6.7-11.6l-11.29-6.52c-4.14-2.39-9.25-2.39-13.4,0l-11.29,6.52c-4.14,2.39-6.7,6.82-6.7,11.6v13.04c0,4.79,2.55,9.21,6.7,11.6l11.29,6.52c4.14,2.39,9.25,2.39,13.4,0l11.29-6.52c4.14-2.39,6.7-6.82,6.7-11.6Z"
        fill="currentColor"
      />
      <path
        d="M269.02,186.56v-13.04c0-4.79-2.55-9.21-6.7-11.6l-11.29-6.52c-4.14-2.39-9.25-2.39-13.4,0l-11.29,6.52c-4.14,2.39-6.7,6.82-6.7,11.6v13.04c0,4.79,2.55,9.21,6.7,11.6l11.29,6.52c4.14,2.39,9.25,2.39,13.4,0l11.29-6.52c4.14-2.39,6.7-6.82,6.7-11.6Z"
        fill="currentColor"
      />
      <path
        d="M330.52,21.75v-5.57c0-4.79-2.55-9.21-6.7-11.6l-4.82-2.79c-4.14-2.39-9.25-2.39-13.4,0l-4.82,2.79c-4.14,2.39-6.7,6.82-6.7,11.6v5.57c0,4.79,2.55,9.21,6.7,11.6l4.82,2.79c4.14,2.39,9.25,2.39,13.4,0l4.82-2.79c4.14-2.39,6.7-6.82,6.7-11.6Z"
        fill="currentColor"
      />
      <path
        d="M196.63,211.55v-5.57c0-4.79-2.55-9.21-6.7-11.6l-4.82-2.79c-4.14-2.39-9.25-2.39-13.4,0l-4.82,2.79c-4.14,2.39-6.7,6.82-6.7,11.6v5.57c0,4.79,2.55,9.21,6.7,11.6l4.82,2.79c4.14,2.39,9.25,2.39,13.4,0l4.82-2.79c4.14-2.39,6.7-6.82,6.7-11.6Z"
        fill="currentColor"
      />
      {/* Blue accent connector */}
      <path d="M293.32,145.93c.33.17.33.34,0,.51v-.51Z" fill="#337FDB" />
    </svg>
  );
};

export default PortfolioIcon;
